<script setup>
    import { useStageStore } from '@/stores/stage';
    import { computed, defineProps } from "vue";
    import { useI18n } from 'vue-i18n';

    const formStorage = useStageStore();
    const { t } = useI18n();

    const props = defineProps({
        stage: Object
    })

    /*
    const surveyProgressInPercent = computed(() => {
        return `${(Math.round(formStorage.getNumberOfGivenAnswers / formStorage.getSurveySize * 100))}`
    })
    const surveyProgressValue = computed(() => {
        return formStorage.getNumberOfGivenAnswers
    })
    const surveyProgressMax = computed(() => {
        return formStorage.getSurveySize
    })
    */

    const getPathTypeProgressInPercent = (pathType) => {
        return `${(Math.round(pathType.stagesAnswered / pathType.stagesTotal * 100))}`
    }

    const getPathTypeColor = (pathType) => {
        const pathValues = formStorage.getPathById(pathType.id)[0];
        if (pathValues) {
            return pathValues.color;
        }
        return '#f08600';
    }

    const getPathTypeValues = (currentQuestionPathTypeId) => {
        const currentPathType = formStorage.pointsPerPathType.filter(obj => (obj.id === currentQuestionPathTypeId));
        return currentPathType;
    }

</script>

<template>
    <div class="survey-progress">

        <!--
        <div class="total-progress">
            <div class="progress-bar-container">
                <div :title="t('survey-progress-current-stage')" id="current-stage" class="shape-circle current-stage">
                    <span>{{ surveyProgressValue }}</span>
                </div>

                <div class="progress" role="progressbar" :aria-label="t('survey-progress-percent')" :aria-valuenow="surveyProgressValue" aria-valuemin="0" :aria-valuemax="surveyProgressMax">
                    <div class="progress-bar" :style="`width: ${surveyProgressInPercent}%`">
                        <span class="sr-only">{{`${surveyProgressInPercent} %`}}</span>
                    </div>
                </div>

                <div :title="t('survey-progress-total-stages')" id="total-stages" class="shape-circle total-stage">
                    <span>{{ formStorage.getSurveySize }}</span>
                </div>
            </div>
            <div aria-hidden="true" class="survey-progress--percent">{{`${surveyProgressInPercent} %`}}</div>
        </div>
        -->

        <div v-for="pathType in getPathTypeValues(stage.node.pathType)" :key="pathType.id" :class="`single-path path-${pathType.id}`">
            <div class="progress-bar-container">
                <div :title="t('survey-progress-current-stage')" class="shape-circle current-stage">
                    <span>{{ pathType.stagesAnswered }}</span>
                </div>

                <div class="progress" role="progressbar" :aria-label="t('survey-progress-percent')" :aria-valuenow="pathType.stagesAnswered" aria-valuemin="0" :aria-valuemax="pathType.stagesTotal">
                    <div class="progress-bar" :style="`width: ${getPathTypeProgressInPercent(pathType)}%; background: ${getPathTypeColor(pathType)};`">
                        <span class="sr-only">{{`${getPathTypeProgressInPercent(pathType)} %`}}</span>
                    </div>
                </div>

                <div :title="t('survey-progress-total-stages')" class="shape-circle total-stage">
                    <span>{{ pathType.stagesTotal }}</span>
                </div>
            </div>
            <div aria-hidden="true" class="survey-progress--percent">{{`${getPathTypeProgressInPercent(pathType)} %`}}</div>
        </div>
    </div>
</template>